/**
 * @file スタイル設定：z-index 定数管理
 */

export const zIndex = {
    fullscreen: "10000",
    fullvideoButtonlist: "10",
    fullvideoContentInteraction: "20",
    fullvideoContentsAd: "110",
    fullvideoContentsController: "2",
    fullvideoContentsDataLoading: "99",
    fullvideoController: "50",
    fullvideoCover: "2",
    fullvideoDrawerNote: "11",
    fullvideoLoading: "60",
    fullvideoPayment: "300",
    fullvideoSubmenu: "8",
    fullvideoSubtitle: "1",
    header: "100",
    headerAccountmenu: "4000",
    languagemenu: "90",
    modal: "3000",
    popup: "200",
    sliderArrow: "8",
    sliderCover: "2",
    sliderDot: "8",
    sliderZoomButton: "9",
    sliderZoomContent: "2000",
    tooltip: "80",
};
